import { render, staticRenderFns } from "./TvRemoteController.vue?vue&type=template&id=0a1893f6"
import script from "./TvRemoteController.vue?vue&type=script&lang=js"
export * from "./TvRemoteController.vue?vue&type=script&lang=js"
import style0 from "./TvRemoteController.vue?vue&type=style&index=0&id=0a1893f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports